import styled from "styled-components";

export const SurveyPatients = styled.div`
  height: 100%;
  position: relative;
  .surveys-list-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    &__title {
      font-family: "Nunito Sans Bold";
      font-size: 16px;
      color: #1F1F52;
    }
    &__remove-selection {
    }
  }
  .input-msg {
    color: #8C8DA4;
    font-family: Nunito Sans;
    font-size: 15px;
    margin-bottom: 20px;
  }
  .patients-list {
    &__results {
      color: #C0BFDC;
      font-family: "Nunito Sans";
      font-size: 17px;
      font-style: italic;
      margin: 20px 27px;
        &--hidden {
          /* visibility: hidden; */
        display: none;
      }
    }
    &__container {
      overflow: auto;
      height: 100%;
      display: flex;
      flex-direction: column;
    }
    .zaia-reaction {
      height: 100%;
      display: flex;
    }
    .search-symptoms {
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      color: #3E3DA3;
      margin: auto;
      &__img {
        width: 250px;
        justify-content: center;
        align-self: center;
      }
      &__text {
        color: #36369B;
        text-align: center;
        font-family: Nunito Sans;
        font-size: 24px;
        margin-top: 40px;
      }
    }
    .empty-symptoms {
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      color: #3E3DA3;
      margin: 40px;
      &__img {
        width: 200px;
        justify-content: center;
        align-self: center;
      }
      &__title {
        font-family: "Nunito Sans Bold";
        font-size: 30px;
        margin-top: 20px;
      }
      &__subtitle {
        margin-top: 20px;
        font-size: 1em;
        color: #37379B;
      }
    }
  }
`

export const ItemPatient = styled.div`
  .item {
    box-sizing: border-box;
    display: flex;
    margin: 10px 0px; 
    border-radius: 20px;
    padding: 10px;
    width: 100%;
    background-color: ${({disabled}) => disabled ? "#F7F8FA" : "#EDEBF7" };
    font-family: Nunito Sans;
    color: ${({disabled}) => disabled ? "#3E3E5B" : "#1F1F52" } ; 
    outline: none;
    border: none;
    cursor: ${({ disabled}) =>  disabled ? "default" : "pointer" };
    justify-content: space-between;
    &__left {
      display: flex;
      align-items: center;
      width: 100%;
    }
    &__subtitle {
      font-size: 12px;
      color: ${({disabled}) => disabled ? "#3E3E5B" : "#707582" }; 
    }
    &__icon {
      margin-right: 5px;
      font-size: 20px;
      color: #1168FF;
    }
    &__title {
      font-size: 14px;
      color: ${({selected}) => selected ? "#1168FF" : "#1F1F52"};
      font-family: ${({selected}) => selected ? "Nunito Sans bold" : "Nunito Sans"};
    }
    &__text {
      margin-left: 5px;
    }
    &--disabled {
      background-color: #F7F8FA;
      cursor: default;
      color: #707582;
      opacity: 0.45;
    }
    &--selected {
      color: #1168FF;
      font-family: Nunito Sans bold;
    }
    &__radio-button {
      border-radius: 50%;
      width: 20px;
      height: 20px;
      border: 1.2px solid ${({ disabled}) =>  disabled ? "#CFD3DD" : "#2A28D6"};
      background-color: ${({ disabled}) => disabled ? "#70758242" : "#FFFFFF"};
      padding: 3px;
      box-sizing: border-box;
      display: flex;
      margin-right: 5px;
      &-content {
        width: 14px;
        border-radius: 50%;
        background-color: #1168FF;
        display: ${({selected}) => selected ? "block" : "none"};
      }
    }
  }
`